if (!customElements.get('quiz-component')) {
  class Quiz extends HTMLElement {
    constructor() {
      super();
      this.data = JSON.parse(document.querySelector('#quiz-settings').textContent);
      this.nextButton = this.querySelector('#next-button');
      this.nextButton.addEventListener('click', this.nextButtonListener.bind(this));
      this.prevButton = this.querySelector('#prev-button');
      this.prevButton.addEventListener('click', this.prevButtonListener.bind(this));
      this.cats = 1; // Default to 1 cat
      this.catNames = [];
      this.catDetails = [];
      this.foodType = '';
      this.foodPreference = [];
      this.currentCatIndex = 0;
      this.catQuestions = ['age', 'weight', 'activity', 'food_type', 'food_preference', 'health'];
      this.currentQuestionIndex = 0;
      this.dynamicContent = this.querySelector('.quiz-dynamic-content');
      this.loadingOverlay = this.querySelector('.loading-overlay');
      this.page = 0;
      this.quiz = document.querySelector('.quiz');
      this.quizState = {};
      console.log(this.quiz)

      // Load saved state from localStorage if available
      this.loadFromLocalStorage();

      this.url = window.location.href;
      this.url = new URL(this.url);
      this.url.searchParams.set('page', this.page);
      window.history.pushState({ page: this.page }, null, this.url);

      window.addEventListener("popstate", (event) => {
        this.showLoading();
        this.page = event.state.page;
        this.displayPage(this.page);
        this.buttonState();
      })
    }

    connectedCallback() {
      this.showLoading();
      // Simulate network delay on initial load
      setTimeout(() => {
        this.displayPage(this.page);
      }, 500);
      this.buttonState();
    }

    buttonState() {
      const pageData = this.data[parseInt(this.page)];
      if(pageData.type === 'results') {
        this.nextButton.classList.add('hidden');
        this.prevButton.classList.add('hidden');
      } else {
        this.nextButton.classList.remove('hidden');
        this.prevButton.classList.remove('hidden');
      }
      if (this.page <= this.data.length - 1) {
        this.nextButton.classList.add('active');
      } else {
        this.nextButton.classList.remove('active');
      }
      if (this.page > 0) {
        this.prevButton.classList.add('active');
      } else {
        this.prevButton.classList.remove('active');
      }
    }

    getPage() {
      this.page = parseInt(this.url.searchParams.get('page'));
      return this.page;
    }

    showLoading() {
      this.loadingOverlay.classList.add('active');
    }

    hideLoading() {
      this.loadingOverlay.classList.remove('active');
    }

    // Save current state to localStorage
    saveToLocalStorage() {
       this.quizState = {
        page: this.page,
        cats: this.cats,
        catNames: this.catNames,
        catDetails: this.catDetails,
        foodType: this.foodType,
        foodPreference: this.foodPreference,
        currentCatIndex: this.currentCatIndex,
        currentQuestionIndex: this.currentQuestionIndex,
        resultsShown: this.quiz && this.quiz.classList.contains('results'),
        resultsData: this.resultsData || null
      };
      
      localStorage.setItem('clawz_quiz_state', JSON.stringify(this.quizState));
    }

    // Load state from localStorage
    loadFromLocalStorage() {
      try {
        const savedState = localStorage.getItem('clawz_quiz_state');
        
        if (savedState) {
          this.quizState = JSON.parse(savedState);
          
          // Restore all state variables
          this.page = this.quizState.page || 0;
          this.cats = this.quizState.cats || 1;
          this.catNames = this.quizState.catNames || [];
          this.catDetails = this.quizState.catDetails || [];
          this.foodType = this.quizState.foodType || '';
          // Handle foodPreference as an array
          this.foodPreference = Array.isArray(this.quizState.foodPreference) 
            ? this.quizState.foodPreference 
            : (this.quizState.foodPreference ? [this.quizState.foodPreference] : []);
          this.currentCatIndex = this.quizState.currentCatIndex || 0;
          this.currentQuestionIndex = this.quizState.currentQuestionIndex || 0;
          this.resultsData = this.quizState.resultsData || null;
          
          // If we don't have enough cat details initialized, initialize them
          if (this.catDetails.length < this.cats) {
            const missingCats = this.cats - this.catDetails.length;
            for (let i = 0; i < missingCats; i++) {
              this.catDetails.push({
                age: '',
                activity: '',
                health: '',
                weight: ''
              });
            }
          }
          
          // If we don't have enough cat names initialized, initialize them
          if (this.catNames.length < this.cats) {
            const missingNames = this.cats - this.catNames.length;
            for (let i = 0; i < missingNames; i++) {
              this.catNames.push('');
            }
          }
        }
      } catch (error) {
        console.error('Error loading quiz state from localStorage:', error);
        // Reset to defaults if there's an error
        this.page = 0;
        this.cats = 1;
        this.catNames = [''];
        this.catDetails = [{ age: '', weight: '', activity: '', health: '' }];
        this.foodType = '';
        this.foodPreference = [];
        this.currentCatIndex = 0;
        this.currentQuestionIndex = 0;
      }
    }

    // Clear saved state
    clearLocalStorage() {
      localStorage.removeItem('clawz_quiz_state');
    }

    displayPage(page) {
      this.showLoading();
      
      // Clear current content
      this.dynamicContent.innerHTML = '';
      
      const pageData = this.data[parseInt(page)];
      
      // Update progress bar based on current stage
      if (pageData.stage) {
        this.updateProgressBar(pageData.stage);
      }
      
      // Simulate network delay or content loading time
      setTimeout(() => {
        if(pageData.image) {
          const image = document.createElement('img');
          image.src = pageData.image;
          image.srcset = `${pageData.image}&width=165 165w, ${pageData.image}&width=320 320w, ${pageData.image}&width=640 640w`;
          image.sizes = '(min-width: 640px) 640px, (min-width: 480px) 480px, (min-width: 320px) 320px, 165px';
          image.width = 640;
          image.height = 450;
          
          // Add load event listener to hide loading when image is loaded
          image.onload = () => {
            this.hideLoading();
          };
          
          this.dynamicContent.appendChild(image);
        } else {
          // If no image, hide loading after a short delay
          setTimeout(() => {
            this.hideLoading();
          }, 300);
        }
        
        const info = document.createElement('p');
        info.innerHTML = pageData.info.replace('{catName}', this.catNames[this.currentCatIndex]);
        info.classList.add('info-text', 'text-xl', 'font-medium', 'mb-1', 'text-center');
        this.dynamicContent.appendChild(info);

        if(pageData.prompt2) {
          const prompt2 = document.createElement('div');
          prompt2.innerHTML = pageData.prompt2;
          prompt2.classList.add('prompt-container', 'mb-6', 'text-center', 'flex', 'info-text');
          this.dynamicContent.appendChild(prompt2);
        }
        
        const prompt = document.createElement('div');
        prompt.innerHTML = pageData.prompt;
        prompt.classList.add('prompt-container', 'mb-6', 'text-center', 'flex');
        this.dynamicContent.appendChild(prompt);
        
        // Handle specific page types
        if (pageData.type === 'cat_count') {
          this.setupCatCountPage();
        } else if (pageData.type === 'cat_names') {
          this.setupCatNamesPage();
        } else if (pageData.type === 'food_preference') {
          this.setupFoodPreferencePage();
        } else if (pageData.type === 'cat_details') {
          this.setupCatDetailsPage();
        } else if (pageData.type === 'results') {
          if(this.dataset.turnOffResults === 'true') {
            this.redirectUrl = 'https://clawzcatfood.com/a/account/custom-tools/dynamic-box?product=7974140968996';
            window.location.href = this.redirectUrl;
            return;
          }
          this.setupResultsPage();
        }

        if(pageData.type !== 'results') {
          this.quiz.classList.remove('results');
        }
        
        // Save state after displaying the page
        this.saveToLocalStorage();
      }, 500);
    }

    handleNumberOfCatsInput() {
      const numberOfCatsInput = document.getElementById('number-of-cats');
      if (numberOfCatsInput) {
        this.cats = parseInt(numberOfCatsInput.value) || 1;
        
        // Initialize cat details arrays
        this.catNames = new Array(this.cats).fill('');
        this.catDetails = new Array(this.cats).fill(null).map(() => ({
          age: '',
          weight: '',
          activity: '',
          health: ''
        }));
        
        // Save state after updating cat count
        this.saveToLocalStorage();
      }
    }

    setupCatCountPage() {
      const numberOfCatsInput = document.getElementById('number-of-cats');
      if (numberOfCatsInput) {
        // Set the input value from the stored state
        numberOfCatsInput.value = this.cats;
        
        numberOfCatsInput.addEventListener('change', () => {
          this.handleNumberOfCatsInput();
        });
        
        // Initialize with default value
        this.handleNumberOfCatsInput();
      }
    }

    setupCatNamesPage() {
      const container = document.getElementById('cat-names-container');
      if (container) {
        container.innerHTML = '';
        
        for (let i = 0; i < this.cats; i++) {
          const nameInput = document.createElement('div');
          nameInput.classList.add('cat-name-input', 'mb-3');
          nameInput.innerHTML = `
            <label for="cat-name-${i}" class="block mb-1">Cat ${i + 1} name:</label>
            <input type="text" id="cat-name-${i}" class="w-full" placeholder="Cat ${i + 1} Name" value="${this.catNames[i] || ''}">
          `;
          container.appendChild(nameInput);
          
          // Add event listener to save name
          const input = nameInput.querySelector(`#cat-name-${i}`);
          input.addEventListener('change', (e) => {
            this.catNames[i] = e.target.value;
            this.saveToLocalStorage();
          });
        }
      }
    }

    setupFoodPreferencePage() {
      const foodOptions = document.querySelectorAll('input[data-field="foodPreference"]');
      foodOptions.forEach(option => {
        // Check previously selected option
        if (this.foodPreference.includes(option.value)) {
          option.checked = true;
        }
        
        option.addEventListener('change', (e) => {
          this.foodPreference.push(e.target.value);
          this.saveToLocalStorage();
        });
      });
    }

    setupCatDetailsPage() {
      const container = document.getElementById('cat-details-container');
      if (container) {
        container.innerHTML = '';
        
        // Get the current cat name and question
        const catName = this.catDetails[this.currentCatIndex].name || this.catNames[this.currentCatIndex] || `Cat ${this.currentCatIndex + 1}`;
        const currentQuestion = this.catQuestions[this.currentQuestionIndex];
        
        // Create a panel for the current question
        const questionPanel = document.createElement('div');
        questionPanel.classList.add('question-panel', 'mb-6');
        
        // Add subheader showing which cat we're on
        const subheader = document.createElement('p');
        subheader.textContent = `Cat ${this.currentCatIndex + 1} of ${this.cats}`;
        subheader.classList.add('sub-title');
        container.appendChild(subheader);
        
        // Find the current question data from our JSON structure
        const catDetailsData = this.data.find(item => item.type === 'cat_details');
        if (catDetailsData && catDetailsData.questions) {
          // Find the question set that matches the current question type
          const questionSet = catDetailsData.questions.find(q => q.type === currentQuestion);
          
          if (questionSet) {
            // Special handling for age question which has an image and multiple sub-questions
            if(questionSet.image) {
              const image = document.createElement('img');
              image.src = questionSet.image;
              image.classList.add('w-full', 'mb-4');
              image.srcset = `${image.src}&width=165 165w, ${image.src}&width=320 320w, ${image.src}&width=640 640w`;
              image.sizes = '(min-width: 640px) 640px, (min-width: 480px) 480px, (min-width: 320px) 320px, 165px';
              image.width = 640;
              image.height = 450;

              const imageWrapper = document.createElement('div');
              imageWrapper.classList.add('image-wrapper-questions');
              imageWrapper.appendChild(image);
              questionPanel.appendChild(imageWrapper);


              if(questionSet.type === 'age') {
                image.classList.add('age-image');
                console.log(questionSet.type, 'questionSet.type')

              }
            }

              
              // For age question, we have an array of HTML strings
            if (questionSet.html && Array.isArray(questionSet.html)) {
              questionSet.html.forEach(htmlString => {
                // Replace placeholders in the HTML
                const processedHtml = htmlString
                  .replace(/{catName}/g, catName)
                  .replace(/{index}/g, this.currentCatIndex);
                
                // Create a temporary container to hold the HTML
                const tempContainer = document.createElement('div');
                tempContainer.innerHTML = processedHtml;
                
                // Append the HTML to the question panel
                while (tempContainer.firstChild) {
                  questionPanel.appendChild(tempContainer.firstChild);
                }
              });
            }
             else {
              // For other question types, we have a single HTML string
              if (questionSet.html) {
                // Replace placeholders in the HTML
                const processedHtml = questionSet.html
                  .replace(/{catName}/g, catName)
                  .replace(/{index}/g, this.currentCatIndex);
                
                // Create a temporary container to hold the HTML
                const tempContainer = document.createElement('div');
                tempContainer.innerHTML = processedHtml;
                
                // Append the HTML to the question panel
                while (tempContainer.firstChild) {
                  questionPanel.appendChild(tempContainer.firstChild);
                }
              }
            }
            
            // After adding all HTML, bind events to inputs
            this.bindEventsToInputs(questionPanel, catName);
          }
        }
        
        container.appendChild(questionPanel);
      }
    }

    setupResultsPage() {
      document.querySelectorAll('.image-with-text section').forEach(item => item.classList.remove('hidden'));
      document.querySelectorAll('.reviews-section section').forEach(item => item.classList.remove('hidden'));
      const selectedFoodType = {}
      this.quiz.classList.add('results');
      const container = document.querySelector('.results-content');
      const allCatsNamesContainer = document.querySelector('.all-cats-names');
      const recommendedPlan = document.querySelector('.recommended-plan');
      allCatsNamesContainer.innerHTML = '';
      if (container) {
        this.catNames.forEach((catName, index) => {
          const catNameElement = document.createElement('p');
          catNameElement.textContent = catName;
          catNameElement.classList.add('cat-name');
          allCatsNamesContainer.appendChild(catNameElement);
        });

        this.quizState.catDetails.forEach((catDetail, index) => {
          catDetail.foodType.forEach((foodType, indexCatFood) => {

            if(!selectedFoodType[foodType]) {
              selectedFoodType[foodType] = +1;
              if(indexCatFood === catDetail.foodType.length - 1 && index === this.quizState.catDetails.length - 1) {
                recommendedPlan.append('and ')
              }
              const foodTypeElement = document.createElement('span');
              foodTypeElement.classList.add('popup-link');
              foodTypeElement.dataset.popup = foodType.toLowerCase().trim();
              foodTypeElement.textContent = foodType;
              recommendedPlan.appendChild(foodTypeElement);

              if(indexCatFood !== catDetail.foodType.length - 1 || index !== this.quizState.catDetails.length - 1) {
                recommendedPlan.append(', ')
              }
              
            } else {
              selectedFoodType[foodType] = selectedFoodType[foodType] + 1;

            }
          })
        });

        const popupLinks = document.querySelectorAll('.popup-link');
        popupLinks.forEach(link => {
          link.addEventListener('click', () => {
            const popupId = link.dataset.popup;
            console.log(link.dataset.popup, 'QAZ', !!popupId)
            this.showNutritionDialog(popupId) 
            });
        });

        console.log(selectedFoodType)

      }
    }

    showNutritionDialog(popupId) {


      const dialogOverlay = document.getElementById('nutrition-dialog-overlay');
      const dialogTitle = document.getElementById('nutrition-dialog-title');
      const dialogContent = document.getElementById('nutrition-dialog-content');
      const closeButton = document.getElementById('nutrition-dialog-close');

      const content = document.querySelector(`#${popupId}`);
      if(!content) return;

      dialogOverlay.classList.add('active');
      dialogContent.innerHTML = content.innerHTML;
      
      
      // Close dialog when "Got it" button is clicked
      closeButton.addEventListener('click', () => {
        dialogOverlay.classList.remove('active');
      });
      
      // Also close dialog when clicking outside the dialog
      dialogOverlay.addEventListener('click', (e) => {
        if (e.target === dialogOverlay) {
          dialogOverlay.classList.remove('active');
        }
      });

    }

    
    bindEventsToInputs(container, catName) {
      // Find all inputs, selects, and checkboxes with data-field attribute
      const inputs = container.querySelectorAll('input[data-field], select[data-field]');
      
      // First, handle health concerns container visibility based on saved state
      const healthConcernsContainer = container.querySelector('.health-concerns-container');
      if (healthConcernsContainer) {
        const hasHealthConcerns = this.catDetails[this.currentCatIndex].health === 'has_health_concerns';
        healthConcernsContainer.style.display = hasHealthConcerns ? 'block' : 'none';
      }
      
      inputs.forEach(input => {
        const fieldName = input.getAttribute('data-field');
        
        // Initialize the field in catDetails if it doesn't exist
        if (fieldName === 'healthConcerns' || fieldName === 'foodType') {
          // Special handling for healthConcerns and foodType checkboxes which use an array
          if (!Array.isArray(this.catDetails[this.currentCatIndex][fieldName])) {
            this.catDetails[this.currentCatIndex][fieldName] = [];
          }
          
          // Set initial checked state based on stored values
          if (this.catDetails[this.currentCatIndex][fieldName].includes(input.value)) {
            input.checked = true;
            
            // Show dialog for already checked health concerns on page load
            if (fieldName === 'healthConcerns') {
              // We don't want to show dialogs on page load, only when user checks the box
              // this.showHealthDialog(input.value);
            }
          }
          
          // Add event listener for checkboxes
          input.addEventListener('change', (e) => {
            const value = e.target.value;
            const checked = e.target.checked;
            
            if (checked && !this.catDetails[this.currentCatIndex][fieldName].includes(value)) {
              this.catDetails[this.currentCatIndex][fieldName].push(value);
              
              // Show dialog when health concern checkbox is checked
              if (fieldName === 'healthConcerns') {
                this.showHealthDialog(value);
              }
            } else if (!checked) {
              this.catDetails[this.currentCatIndex][fieldName] = 
                this.catDetails[this.currentCatIndex][fieldName].filter(item => item !== value);
            }           
            this.saveToLocalStorage();
          });
        } else {
          // For other input types (text, number, radio, select)
          if (this.catDetails[this.currentCatIndex][fieldName] === undefined) {
            this.catDetails[this.currentCatIndex][fieldName] = '';
          }
          
          // Set initial value or checked state based on stored values
          if (input.type === 'radio') {
            if (this.catDetails[this.currentCatIndex][fieldName] === input.value) {
              input.checked = true;
            }
            
            // Special handling for health radio buttons to show/hide health concerns
            if (fieldName === 'health') {
              input.addEventListener('change', (e) => {
                const healthConcernsContainer = container.querySelector('.health-concerns-container');
                if (healthConcernsContainer) {
                  if (e.target.value === 'has_health_concerns') {
                    healthConcernsContainer.style.display = 'block';
                  } else {
                    healthConcernsContainer.style.display = 'none';
                    // Clear health concerns when switching away from "has health concerns"
                    this.catDetails[this.currentCatIndex]['healthConcerns'] = [];
                  }
                }
                
                this.catDetails[this.currentCatIndex][fieldName] = e.target.value;
                this.saveToLocalStorage();
              });
            } else {
              // Standard radio button handling
              input.addEventListener('change', (e) => {
                this.catDetails[this.currentCatIndex][fieldName] = e.target.value;
                this.saveToLocalStorage();
              });
            }
          } else {
            input.value = this.catDetails[this.currentCatIndex][fieldName];
            
            // Add event listener for non-radio inputs
            input.addEventListener('change', (e) => {
              this.catDetails[this.currentCatIndex][fieldName] = e.target.value;
              this.saveToLocalStorage();
            });
          }
        }
      });
    }

    renderQuestionFromJSON(container, questionData, catName) {
      // This method is no longer needed as we're using direct HTML from JSON
      // Keeping it as a placeholder in case we need to revert or for reference
    }

    buildCats() {
      this.showLoading();
      this.dynamicContent.innerHTML = '';
      
      setTimeout(() => {
        for (let i = 0; i < this.cats; i++) {
          const cat = document.createElement('div');
          cat.classList.add('cat');
          cat.innerHTML = `Cat ${i + 1}`;
          this.dynamicContent.appendChild(cat);
        }
        this.hideLoading();
      }, 500);
    }

    nextButtonListener(evt) {
      evt.preventDefault();
      
      // Validate current page before proceeding
      if (!this.validateCurrentPage()) {
        return; // Stop if validation fails
      }
      
      // Get current page data
      const currentPageData = this.data[this.page];
      
      // Handle specific page transitions
      if (currentPageData.type === 'cat_count') {
        this.handleNumberOfCatsInput();
      } else if (currentPageData.type === 'cat_names') {
        // Save cat names from inputs
        for (let i = 0; i < this.cats; i++) {
          const nameInput = document.getElementById(`cat-name-${i}`);
          if (nameInput) {
            this.catNames[i] = nameInput.value;
          }
        }
        this.saveToLocalStorage();
      } else if (currentPageData.type === 'cat_details') {
        // Move to next question or next cat
        if (this.currentQuestionIndex < this.catQuestions.length - 1) {
          // Move to next question for the same cat
          this.currentQuestionIndex++;
          this.saveToLocalStorage();
          this.displayPage(this.page); // Refresh the page with the new question
          return;
        } else if (this.currentCatIndex < this.cats - 1) {
          // Move to the first question for the next cat
          this.currentCatIndex++;
          this.currentQuestionIndex = 0;
          this.saveToLocalStorage();
          this.displayPage(this.page); // Refresh the page with the new cat
          return;
        }
        // If we've completed all cats and all questions, proceed to next page
      }

      // Standard page navigation
      if (this.page < this.data.length - 1) {
        this.showLoading();
        this.page++;
        this.url.searchParams.set('page', this.page);
        this.displayPage(this.page);
        window.history.pushState({ page: this.page }, null, this.url);
        this.buttonState();
        this.saveToLocalStorage();
      }
    }

    prevButtonListener(evt) {
      evt.preventDefault();
      
      // Get current page data
      const currentPageData = this.data[this.page];
      
      // Handle specific page transitions
      if (currentPageData.type === 'cat_details') {
        // Move to previous question or previous cat
        if (this.currentQuestionIndex > 0) {
          // Move to previous question for the same cat
          this.currentQuestionIndex--;
          this.saveToLocalStorage();
          this.displayPage(this.page); // Refresh the page with the new question
          return;
        } else if (this.currentCatIndex > 0) {
          // Move to the last question for the previous cat
          this.currentCatIndex--;
          this.currentQuestionIndex = this.catQuestions.length - 1;
          this.saveToLocalStorage();
          this.displayPage(this.page); // Refresh the page with the new cat
          return;
        }
        // If we're at the first question of the first cat, proceed to previous page
      }
      
      // Standard page navigation
      if (this.page > 0) {
        this.showLoading();
        this.page--;
        this.url.searchParams.set('page', this.page);
        this.displayPage(this.page);
        window.history.pushState({ page: this.page }, null, this.url);
        this.buttonState();
        this.saveToLocalStorage();
      }
    }

    updateProgressBar(currentStage) {
      // Reset all progress elements
      const allStages = document.querySelectorAll('.progress-stage');
      const allSeparators = document.querySelectorAll('.progress-seperator');
      const allWrappers = document.querySelectorAll('.progress-stage-wrapper');
      
      // Remove active class from all elements
      allStages.forEach(stage => stage.parentElement.classList.remove('active'));
      allSeparators.forEach(separator => separator.classList.remove('active'));
      
      // Add active class to elements with stage <= currentStage
      allStages.forEach(stage => {
        const stageNum = parseInt(stage.getAttribute('data-stage'));
        if (stageNum <= currentStage) {
          stage.parentElement.classList.add('active');
        }
      });
      
      allSeparators.forEach(separator => {
        const stageNum = parseInt(separator.getAttribute('data-stage'));
        if (stageNum <= currentStage) {
          separator.classList.add('active');
        }
      });
    }
    

    showHealthDialog(healthConcern) {
      const dialogOverlay = document.getElementById('health-dialog-overlay');
      const dialogTitle = document.getElementById('health-dialog-title');
      const dialogContent = document.getElementById('health-dialog-content');
      const closeButton = document.getElementById('health-dialog-close');
      
      // Dictionary of health concern information
      const healthConcernInfo = {
        'Asthma': {
          title: 'Asthma',
          content: '<p>Processed food and artificial ingredients can worsen inflammation. Clawz is made without  additives or powdered by-products, creating a cleaner feeding environment for cats with  respiratory issues.</p>',
          concern_level: 'low'
        },
        'Cancer': {
          title: 'Cancer',
          content: '<p>Cats with cancer need nutrient-dense, easily digestible food. Clawz uses human-grade meat  and minimal processing to support immune function and help maintain muscle mass during  treatment.</p>',
          concern_level: 'high'
        },
        'Epilepsy': {
          title: 'Epilepsy',
          content: '<p>While not a cure, feeding clean, consistent meals without artificial preservatives or fillers  may reduce inflammation and help avoid dietary triggers.</p>',
          concern_level: 'low'
        },
        'Diarrhea': {
          title: 'Chronic Diarrhea',
          content: '<p>Easily digestible proteins and whole ingredients help soothe sensitive stomachs. Clawz  avoids gums, stabilizers, and meat meals that can trigger digestive upset.</p>',
          concern_level: 'low'
        },
        'Liver Disease': {
          title: 'Liver Disease',
          content: '<p> Cats with liver disease may require highly specific nutrient balances. Introducing a new diet  without vet supervision could worsen symptoms or interfere with treatment.</p>',
          concern_level: 'high'
        },
        'Chronic Kidney Disease': {
          title: 'Chronic Kidney Disease',
          content: '<p>CKD cats often need specialized phosphorus control and lower protein levels depending on  disease stage. Our meals are high in protein and not formulated to treat kidney issues, so  consult your vet before switching.</p>',
          concern_level: 'high'
        },
        'Pancreatitis': {
          title: 'Pancreatitis',
          content: '<p>This condition often requires a strict low-fat, highly digestible diet. While Clawz is gently.</p>',
          concern_level: 'high'
        },
        'Diabetes': {
          title: 'Diabetes',
          content: '<p>Low-carb, high-protein meals help stabilize blood sugar. Clawz recipes avoid starches and  sugars common in kibble and some canned foods, supporting glucose control.</p>',
          concern_level: 'low'
        },
        'Arthritis': {
          title: 'Arthritis',
          content: '<p>Clawz meals are gently cooked and made without inflammatory ingredients like seed oils or  fillers. Clean proteins and anti-inflammatory fats help reduce joint strain and support  mobility.</p>',
          concern_level: 'low'
        },
        'Cystitis': {
          title: 'Cystitis',
          content: '<p>Hydration is key. Clawz is high-moisture, helping support urinary tract health and flush the  bladder. Plus, there are no artificial additives or irritants.</p>',
          concern_level: 'low'
        },
        'Hyperthyroidism': {
          title: 'Hyperthyroidism',
          content: '<p>Clawz avoids soy, gluten, and synthetic iodine sources that can interfere with thyroid  balance. The whole meats and balanced minerals help support a stable diet during treatment.</p>',
          concern_level: 'low'
        },
        'Urinary Disease': {
          title: 'Urinary Disease',
          content: '<p>Urinary issues, including crystals and blockages, can be life-threatening. Though Clawz is  moisture-rich, it is not a prescription diet. A vet can help decide if it\'s safe to transition based  on your cat\'s history and needs.</p>',
          concern_level: 'high'
        },
        'Inflammatory Bowel Disease': {
          title: 'Inflammatory Bowel Disease',
          content: '<p>IBD is a chronic condition that often requires a prescription diet or medical treatment. While  Clawz uses simple, clean ingredients, dietary changes should be made under your vet\'s  guidance to avoid flare-ups.</p>',
          concern_level: 'high'
        },
        'Other': {
          title: 'Other',
          content: '<p>Our clean ingredient list avoids common triggers and inflammatory ingredients that could exacerbate respiratory issues.</p>',
          concern_level: 'low'
        }
      };
      
      dialogOverlay.classList.remove('low')
      dialogOverlay.classList.remove('high')
      dialogOverlay.classList.remove('moderate')
      dialogOverlay.classList.add(healthConcernInfo[healthConcern].concern_level)
      // Set dialog content based on selected health concern
      if (healthConcernInfo[healthConcern]) {
        dialogTitle.textContent = healthConcernInfo[healthConcern].title;
        dialogContent.innerHTML = healthConcernInfo[healthConcern].content;
      } else {
        dialogTitle.textContent = 'Health Information';
        dialogContent.innerHTML = '<p>Please consult with your veterinarian about managing this health concern.</p>';
      }
      
      // Show the dialog
      dialogOverlay.classList.add('active');
      
      // Close dialog when "Got it" button is clicked
      closeButton.addEventListener('click', () => {
        dialogOverlay.classList.remove('active');
      });
      
      // Also close dialog when clicking outside the dialog
      dialogOverlay.addEventListener('click', (e) => {
        if (e.target === dialogOverlay) {
          dialogOverlay.classList.remove('active');
        }
      });
    }
    
    // Show validation message
    showValidationMessage(message) {
      // Remove any existing validation message
      const existingMessage = this.querySelector('.validation-message');
      if (existingMessage) {
        existingMessage.remove();
      }
      
      // Create and show new validation message
      const validationMessage = document.createElement('div');
      validationMessage.classList.add('validation-message', 'text-center');
      validationMessage.textContent = message;
      
      // Insert before the next button
      this.nextButton.parentNode.insertBefore(validationMessage, this.nextButton);
      
      // Auto-hide after 5 seconds
      setTimeout(() => {
        validationMessage.remove();
      }, 5000);
    }
    
    // Validate current page inputs
    validateCurrentPage() {
      const currentPageData = this.data[this.page];
      
      // Validate based on page type
      if (currentPageData.type === 'cat_count') {
        // Cat count validation - ensure a number is selected
        const catCount = parseInt(document.querySelector('input[name="cat-count"]')?.value);
        if (isNaN(catCount)) {
          this.showValidationMessage('Please select the number of cats you have');
          return false;
        }
      } 
      else if (currentPageData.type === 'cat_names') {
        // Cat names validation - ensure all cats have names
        for (let i = 0; i < this.cats; i++) {
          const nameInput = document.getElementById(`cat-name-${i}`);
          if (!nameInput || !nameInput.value.trim()) {
            this.showValidationMessage('Please enter a name for each cat');
            return false;
          }
        }
      }
      else if (currentPageData.type === 'food_preference') {
        // Food preference validation - ensure at least one option is selected
        if (this.foodPreference.length === 0) {
          this.showValidationMessage('Please select at least one food preference');
          return false;
        }
      }
      else if (currentPageData.type === 'cat_details') {
        // Cat details validation - check current question
        const currentQuestion = this.catQuestions[this.currentQuestionIndex];
        const catName = this.catNames[this.currentCatIndex];
        
        if (currentQuestion === 'age') {
          const genderSelected = document.querySelector(`input[name="cat-${this.currentCatIndex}-gender"]:checked`)?.value;
          const ageSelected = document.querySelector(`input[name="cat-${this.currentCatIndex}-age"]`)?.value;
          if (!ageSelected || !genderSelected)  {
            this.showValidationMessage(`Please check ${catName}'s age or gender`);
            return false;
          }
        }
        else if (currentQuestion === 'weight') {
          const weightSelected = document.querySelector(`input[data-field="weight"]:checked`);
          if (!weightSelected) {
            this.showValidationMessage(`Please select ${catName}'s weight`);
            return false;
          }
        }
        else if (currentQuestion === 'activity') {
          const activitySelected = document.querySelector(`input[data-field="activity"]:checked`);
          if (!activitySelected) {
            this.showValidationMessage(`Please select ${catName}'s activity level`);
            return false;
          }
        }
        else if (currentQuestion === 'food_type') {
          const foodTypeSelected = document.querySelector(`input[data-field="foodType"]:checked`);
          if (!foodTypeSelected) {
            this.showValidationMessage(`Please select ${catName}'s current food type`);
            return false;
          }
        }
        else if (currentQuestion === 'health') {
          // Health might be optional, so no validation required
          return true;
        }
      }
      else if (currentPageData.type === 'results') {
        console.log('results')
        this.quiz.classList.add('results');
        return true;
      }
      
      // If we get here, validation passed
      return true;
    }
  }
  customElements.define('quiz-component', Quiz);
}
